import PlanningEvaluationFormContent, {
  ValuesOption,
} from "../../../domains/PlanningEvaluation/PlanningEvaluationFormContent";
import PlanningEvaluationPayload from "../../../domains/PlanningEvaluation/PlanningEvaluationPayload";

import planningAndSchedulingReducer from "./reducer";
import {
  openModal,
  closeModal,
  setPlanningEvaluationData,
  clearPlanningEvaluationData,
  submitPlanningEvaluation,
  submitPlanningEvaluationSuccess,
  submitPlanningEvaluationError,
  resetPlanningEvaluationSubmission,
  fetchPlanningEvaluationStatuses,
  fetchPlanningEvaluationStatusSucess,
  fetchPlanningEvaluationStatusesError,
  closePlanningEvaluationTableModal,
  openPlanningEvaluationTableModal,
  hideEvaluationDetails,
  showEvaluationDetails
} from "./actions";

export interface PlanningAndSchedulingState {
  planningEvaluationData: PlanningEvaluationFormContent | null
  areFilesUploading?: boolean
  hasFileUploadError?: boolean
  isModalOpen: boolean
  isSubmitting: boolean
  hasSubmissionError: boolean
  isFetchingStatuses: boolean
  hasFetchingStatusesError: boolean
  statuses: Array<string>
  submissionSuccess: boolean
  isPlanningEvaluationTableModalOpen: boolean
  isEvaluationDetailsShown: boolean
  selectedEvaluation: PlanningEvaluationPayload | null
}

export const initialState: PlanningAndSchedulingState = {
  planningEvaluationData: {
    gains: undefined,
    requirementStatus: "",
    penalties: undefined,
    details: "",
    valuesOption: "gainsOption" as ValuesOption,
    fileIds: [],
    department: "planning_and_scheduling",
    requirementId: ""
  },
  areFilesUploading: false,
  hasFileUploadError: false,
  isModalOpen: false,
  isSubmitting: false,
  hasSubmissionError: false,
  hasFetchingStatusesError: false,
  isFetchingStatuses: false,
  submissionSuccess: false,
  statuses: [],
  isPlanningEvaluationTableModalOpen: false,
  isEvaluationDetailsShown: false,
  selectedEvaluation: null,
};

export default planningAndSchedulingReducer;

export {
  openModal,
  closeModal,
  setPlanningEvaluationData,
  clearPlanningEvaluationData,
  submitPlanningEvaluation,
  submitPlanningEvaluationSuccess,
  submitPlanningEvaluationError,
  resetPlanningEvaluationSubmission,
  fetchPlanningEvaluationStatuses,
  fetchPlanningEvaluationStatusSucess,
  fetchPlanningEvaluationStatusesError,
  closePlanningEvaluationTableModal,
  openPlanningEvaluationTableModal,
  hideEvaluationDetails,
  showEvaluationDetails
};
